// TODO: Remove these legacy calendar values once the tonal theme becomes the default.
export const CALENDAR_DIVIDER_COLOR_ONE_ON_ONE = "#9596FF";
export const CALENDAR_DIVIDER_COLOR_GROUP = "#9596FF";

export const CALENDAR_BUTTON_COLOR_ONE_ON_ONE = "#D2D2FF";
export const CALENDAR_BUTTON_COLOR_GROUP = "#D2D2FF";

export const CTA_OPACITY_OPEN = "opacity-100";
export const CTA_OPACITY_ACTIVE = "opacity-100";
export const CTA_OPACITY_DEFAULT = "opacity-0 group-hover:opacity-100 group-focus-within:opacity-100";
